import { transformRead } from "./encryption";
import { openUserCache } from "./openCache";

const getFromIndexedDB = async <Data>(dbName: string, id: string, encryptionDisabled = false): Promise<Data> => {
	const db = await openUserCache();
	const store = db.transaction([dbName]).objectStore(dbName);
	const req = store.get(id);

	return new Promise((resolve, reject) => {
		req.onerror = reject;

		req.onsuccess = async () => {
			try {
				if (!req.result) {
					resolve(null);
					return;
				}

				const result = encryptionDisabled ? req.result : await transformRead(req.result.encryptedContent);
				resolve(result);
			} catch (error) {
				console.error(`Error Fetching the data from IndexedDB DB::${dbName}, id::${id}`, error);
				resolve(null);
			}
		};
	});
};

export const getData = async <DataType>(dbName: string, id: string, encryptionDisabled = false): Promise<DataType> => {
	try {
		const result: DataType = await getFromIndexedDB(dbName, id, encryptionDisabled);

		// console.log(`getting data from ${dbName}: "${id}", vracam `, result);
		return result;
	} catch (err) {
		console.error(err);
		return null;
	}
};

export const getAllKeys = async (dbName: string): Promise<string[]> => {
	const db = await openUserCache();
	const store = db.transaction([dbName]).objectStore(dbName);
	const req = store.getAllKeys();

	return new Promise((resolve, reject) => {
		req.onerror = reject;

		req.onsuccess = async () => {
			if (!req.result) {
				resolve([]);
				return;
			}

			resolve(req.result as string[]);
		};
	});
};
